<template>
   <div>
     <hero></hero>
     <l-footer></l-footer>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>